var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import { PermIdentityOutlined } from '@mui/icons-material';
import { toast } from 'react-toastify';
// Internal dependencies
import { UserContext, getAuthHeader } from '../auth';
import { appStyles } from "../App.styles";
import { TextFieldSG } from "../components/TextFieldSG";
import { styles } from "./MyAccount.styles";
import { axiosClient } from "../axios";
import { RoleType } from './types';
import { LOG_LEVELS, SERVICES, ENDPOINTS } from '../constants';
export const MyAccount = function () {
    // Extract translation
    const { t, i18n } = useTranslation();
    // Get user credential
    const user = useContext(UserContext);
    // Invite email
    const [inviteEmail, setInviteEmail] = useState('');
    // Members list
    const [memberList, setMemberList] = useState([]);
    // User role
    const [userRole, setUserRole] = useState(RoleType.User);
    // Plan workspace max seat
    const [maxSeat, setMaxSeat] = useState(1);
    /**
     * Invite member
     * @returns {Promise<void>}
     */
    function sendInviteEmail() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Get authHeader
                const authHeader = yield getAuthHeader(user);
                // Get header
                const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
                // Invite member params
                const params = {
                    memberEmail: inviteEmail,
                };
                // Call get user api
                const res = yield axiosClient.post(`${process.env.SERVER_URL}${ENDPOINTS.USAGE}${ENDPOINTS.ADD_MEMBER}`, params, { headers });
                // Notify user
                toast.success(t("Invitation email has sent to the user"));
                // Clear invite email
                clearInviteEmail();
                // Upadte members list
                const { workspaceMembers } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                setMemberList(workspaceMembers);
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `MyAccount, sendInviteEmail, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.ACCOUNT,
                        userId: user === null || user === void 0 ? void 0 : user.uid,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                // Check if the error is from axios
                if ((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status) {
                    // If yes, notify user with the server error message
                    toast.error((_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message);
                    return;
                }
                ;
                toast.error(t('Something went wrontoastg. We are figuring it out.'));
            }
        });
    }
    /**
     * Remove member from a workspace
     * @param {string} email
     * @returns {Promise<void>}
     */
    function removeMember(email) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Get autheHeader
            const authHeader = yield getAuthHeader(user);
            // Get header
            const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
            //  Call delete member API
            const res = yield axiosClient.delete(`${process.env.SERVER_URL}${ENDPOINTS.USAGE}${ENDPOINTS.REMOVE_MEMBER}/${email}`, { headers });
            const { workspaceMembers } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
            setMemberList(workspaceMembers);
        });
    }
    ;
    /**
     * Clear invite email
     */
    function clearInviteEmail() {
        setInviteEmail('');
    }
    ;
    /**
     * Member Item
     */
    const MemberItem = ({ role, email, userRole }) => {
        const isOwner = role === RoleType.Owner;
        const memberRole = isOwner ? t('Owner') : t('User');
        const isShowRemove = userRole === RoleType.Owner && !isOwner;
        return (_jsx(Paper, Object.assign({ sx: {
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '1rem',
                boxShadow: 'none',
                marginBottom: '1.5rem',
                backgroundColor: '#F8FAF7',
            } }, { children: _jsxs(Grid, Object.assign({ container: true, columnSpacing: 3, sx: { justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: _jsxs(Grid, Object.assign({ container: true, sx: { alignItems: 'stretch' }, columnSpacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, sx: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    } }, { children: _jsx(PermIdentityOutlined, {}) })), _jsxs(Grid, Object.assign({ item: true, xs: true, sx: {
                                        overflow: 'hidden',
                                        maxWidth: 'calc(100%)',
                                    } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text16), { color: '#191C1B', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }) }, { children: email })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { textAlign: 'left', color: '#3F4945' }) }, { children: memberRole }))] }))] })) })), _jsx(Grid, Object.assign({ item: true }, { children: isShowRemove && _jsx(Button, Object.assign({ variant: "text", sx: {
                                fontWeight: '500',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',
                                alignItems: 'center',
                                textAlign: 'center',
                                letterSpacing: '0.00625rem',
                                padding: '0.625rem 1.5rem',
                                background: 'transparent',
                                textTransform: 'none',
                                color: '#d32f2f',
                                width: {
                                    sm: 'auto',
                                    xs: '100%',
                                },
                            }, onClick: () => removeMember(email) }, { children: t('Remove') })) }))] })) })));
    };
    /**
     * Get workspace members list
     */
    const getWorkspaceData = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!user) {
            return;
        }
        // Get autheHeader
        const authHeader = yield getAuthHeader(user);
        // Get header
        const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
        // Call Get user API
        const res = yield axiosClient.get(`${process.env.SERVER_URL}${ENDPOINTS.USER}${ENDPOINTS.GET_USER}`, { headers });
        // Extract workspace data
        const { workspaceMembers, workspaceMax, role } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
        // Set member list, max seat, user role
        setMemberList(workspaceMembers);
        setMaxSeat(workspaceMax);
        setUserRole(role);
    });
    // Get workspace data
    useEffect(() => {
        getWorkspaceData();
    }, []);
    return (_jsxs(Box, Object.assign({ sx: {
            backgroundColor: 'transparent',
            overflow: 'auto',
            height: '100%',
        } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text16), { padding: '0 0 1.5rem', color: '#000000' }) }, { children: t('Account information') })), _jsx(TextFieldSG
            // email text field
            , { 
                // email text field
                name: 'email', label: t('Email Address'), value: user === null || user === void 0 ? void 0 : user.email, disabled: true, variant: "filled" }), _jsx(Divider, { sx: styles.divider }), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text16), { padding: '0 0 1.5rem', color: '#000000' }) }, { children: `${t('Workspace Members')} (${memberList === null || memberList === void 0 ? void 0 : memberList.length}/${maxSeat} ${t('seats used')})` })), userRole === RoleType.Owner &&
                _jsxs(Grid, Object.assign({ container: true, columnSpacing: 2, sx: { justifyContent: 'space-between', alignItems: 'start' } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(TextFieldSG
                            // firstName text field
                            , { 
                                // firstName text field
                                name: 'inviteEmail', label: t('Workspace Member'), placeholder: 'email@studioglobal.ai', value: inviteEmail, onChange: (e) => setInviteEmail(e.target.value) }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Button, Object.assign({ variant: "contained", sx: {
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    lineHeight: '1.25rem',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    letterSpacing: '0.00625rem',
                                    padding: '0.625rem 1.5rem',
                                    marginTop: "0.5rem",
                                    background: '#006B54',
                                    textTransform: 'none',
                                    color: '#FFFFFF',
                                    width: {
                                        sm: 'auto',
                                        xs: '100%',
                                    },
                                    borderRadius: '100px',
                                }, onClick: () => sendInviteEmail() }, { children: t('Invite') })) }))] })), memberList === null || memberList === void 0 ? void 0 : memberList.map((member) => {
                const { role, email } = member;
                return _jsx(MemberItem, { role: role !== null && role !== void 0 ? role : '', email: email !== null && email !== void 0 ? email : '', userRole: userRole });
            })] })));
};
